import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  getHasta, getHastaGelisleri, getTemelMed, guncelleTemelMed,
  getAnamnezHemsListe, getAnamnezHemsDetay, yeniAnamnezHems, guncelleAnamnezHems, silAnamnezHems,
  getAnamnezDoktorListe, getAnamnezDoktorDetay, yeniAnamnezDoktor, guncelleAnamnezDoktor, silAnamnezDoktor,
  getDoktorOrderListe, getDoktorOrderDetay, yeniDoktorOrder, guncelleDoktorOrder, silDoktorOrder,
  getTaniListe, silTani, icd10Ara, taniEkle,
  getDokumanListe, getDokumanUrl, dokumanYukle
} from '../services/api';

function BilgiSatiri({ etiket, deger, link, tel }) {
  const mapsUrl = (val) => {
    if (!val) return null;
    if (val.startsWith('http')) return val;

    const turkiyeKontrol = (lat, lng) =>
      lat >= 36 && lat <= 42 && lng >= 26 && lng <= 45;

    const ondalikRegex = /^(-?[0-9]{1,3}\.[0-9]+)[,\s]+(-?[0-9]{1,3}\.[0-9]+)$/;
    const m1 = val.trim().match(ondalikRegex);
    if (m1) {
      const lat = parseFloat(m1[1]);
      const lng = parseFloat(m1[2]);
      if (turkiyeKontrol(lat, lng))
        return `https://maps.google.com/?q=${lat},${lng}`;
    }

    const dmsRegex = /([0-9]+)[°]\s*([0-9]+)['']\s*([0-9.]+)[""]?\s*([NS])\s+([0-9]+)[°]\s*([0-9]+)['']\s*([0-9.]+)[""]?\s*([EW])/i;
    const m2 = val.trim().match(dmsRegex);
    if (m2) {
      const dmsToDecimal = (d, m, s, dir) => {
        let dec = parseFloat(d) + parseFloat(m)/60 + parseFloat(s)/3600;
        if (dir === 'S' || dir === 'W') dec = -dec;
        return dec;
      };
      const lat = dmsToDecimal(m2[1], m2[2], m2[3], m2[4].toUpperCase());
      const lng = dmsToDecimal(m2[5], m2[6], m2[7], m2[8].toUpperCase());
      if (turkiyeKontrol(lat, lng))
        return `https://maps.google.com/?q=${lat},${lng}`;
    }

    return val;
  };

  return (
    <tr style={{ borderBottom: '1px solid var(--border)' }}>
      <td style={{ padding: '7px 12px', fontWeight: 600, fontSize: 12, color: 'var(--text-muted)', width: '35%', background: '#f8faf9' }}>{etiket}</td>
      <td style={{ padding: '7px 12px', fontSize: 13 }}>
        {tel && deger ? <a href={`tel:${deger.replace(/[()\-_ ]/g,'')}`} style={{ color: 'var(--med-accent)', textDecoration: 'none' }}>{deger}</a>
        : link && deger ? <a href={mapsUrl(deger)} target="_blank" rel="noreferrer" style={{ color: 'var(--med-accent)', textDecoration: 'none', wordBreak: 'break-all' }}>{deger}</a>
        : deger || ''}
      </td>
    </tr>
  );
}

function Bolum({ baslik, children }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ fontWeight: 700, fontSize: 12, color: '#D85A30', marginBottom: 6, paddingBottom: 4, borderBottom: '2px solid #D85A30' }}>{baslik}</div>
      <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid var(--border)' }}>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

function DokumanlarSekme({ kayitNo, hasta, hastaGirisi = false }) {
  const [liste, setListe] = React.useState([]);
  const [yukleniyor, setYukleniyor] = React.useState(true);
  const [yuklemeModu, setYuklemeModu] = React.useState(false);
  const [yukleniyor2, setYukleniyor2] = React.useState(false);
  const [mesaj, setMesaj] = React.useState('');
  const [kameraVar, setKameraVar] = React.useState(false);
  const pdfRef = React.useRef();
  const kameraRef = React.useRef();
  const galeriRef = React.useRef();

  React.useEffect(() => {
    const mobilCihaz = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
    setKameraVar(mobilCihaz);
  }, []);

  const listeyiYukle = () => {
    setYukleniyor(true);
    getDokumanListe(kayitNo)
      .then(res => setListe(res.data))
      .catch(err => console.error(err))
      .finally(() => setYukleniyor(false));
  };

  React.useEffect(() => { listeyiYukle(); }, []);

  const tarihFormat = (tar) => {
    if (!tar) return '-';
    const d = new Date(tar);
    return String(d.getDate()).padStart(2,'0') + '/' + String(d.getMonth()+1).padStart(2,'0') + '/' + d.getFullYear();
  };

  const ikonGoster = (uzanti) => {
    const u = (uzanti || '').toLowerCase();
    if (u === 'pdf') return '📕';
    if (u === 'jpg' || u === 'jpeg') return '🖼️';
    return '📄';
  };

  const dosyaYukle = async (e) => {
    const dosya = e.target.files[0];
    if (!dosya) return;
    setYukleniyor2(true);
    setMesaj('');
    try {
      await dokumanYukle(kayitNo, hasta?.hesapAdi || '', dosya);
      setMesaj('Döküman yüklendi ✓');
      setTimeout(() => setMesaj(''), 3000);
      setYuklemeModu(false);
      listeyiYukle();
    } catch {
      setMesaj('Yükleme hatası!');
    } finally {
      setYukleniyor2(false);
      e.target.value = '';
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <span style={{ fontSize: 13, fontWeight: 600 }}>Hastanın Dökümanları</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {mesaj && <span style={{ fontSize: 12, color: mesaj.includes('✓') ? '#2563C0' : '#A32D2D', fontWeight: 500 }}>{mesaj}</span>}
          {yukleniyor2 && <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Yükleniyor...</span>}
          {!hastaGirisi && <button className="btn btn-primary" style={{ fontSize: 12, padding: '6px 14px' }}
            onClick={() => {
              if (!kameraVar) {
                pdfRef.current.click();
              } else {
                setYuklemeModu(!yuklemeModu);
              }
            }}>
            ➕ Döküman Ekle
          </button>}
        </div>
      </div>

      <input ref={pdfRef} type="file" accept=".pdf,application/pdf" style={{ display: 'none' }} onChange={dosyaYukle} />

      {yuklemeModu && (
        <div className="card" style={{ marginBottom: 12 }}>
          <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 14, color: 'var(--med-primary)' }}>Döküman Ekle</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
            <div style={{ textAlign: 'center' }}>
              <input ref={pdfRef} type="file" accept=".pdf,application/pdf" style={{ display: 'none' }} onChange={dosyaYukle} />
              <button className="btn btn-secondary" style={{ width: '100%', padding: '16px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}
                onClick={() => pdfRef.current.click()}>
                <span style={{ fontSize: 32 }}>📄</span>
                <span style={{ fontSize: 12, fontWeight: 500 }}>PDF Seç</span>
                <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>Dosyalardan</span>
              </button>
            </div>
            <div style={{ textAlign: 'center' }}>
              <input ref={kameraRef} type="file" accept="image/*" capture="environment" style={{ display: 'none' }} onChange={dosyaYukle} />
              <button className="btn btn-secondary" style={{ width: '100%', padding: '16px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}
                onClick={() => kameraRef.current.click()}>
                <span style={{ fontSize: 32 }}>📷</span>
                <span style={{ fontSize: 12, fontWeight: 500 }}>Kamera</span>
                <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>Fotoğraf Çek</span>
              </button>
            </div>
            <div style={{ textAlign: 'center' }}>
              <input ref={galeriRef} type="file" accept="image/jpeg,image/jpg" style={{ display: 'none' }} onChange={dosyaYukle} />
              <button className="btn btn-secondary" style={{ width: '100%', padding: '16px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}
                onClick={() => galeriRef.current.click()}>
                <span style={{ fontSize: 32 }}>🖼️</span>
                <span style={{ fontSize: 12, fontWeight: 500 }}>Galeri</span>
                <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>JPG Seç</span>
              </button>
            </div>
          </div>
          <div style={{ marginTop: 12, textAlign: 'right' }}>
            <button className="btn btn-secondary" style={{ fontSize: 12 }} onClick={() => setYuklemeModu(false)}>İptal</button>
          </div>
        </div>
      )}

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {yukleniyor ? <div className="loading">Yükleniyor...</div>
        : liste.length === 0 ? <div className="empty">Döküman kaydı yok</div>
        : liste.map(d => (
          <a key={d.id}
            href={getDokumanUrl(d.id)}
            target="_blank"
            rel="noreferrer"
            style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderBottom: '1px solid var(--border)', textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}
            onMouseEnter={e => e.currentTarget.style.background = 'var(--med-light)'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            <span style={{ fontSize: 24, flexShrink: 0 }}>{ikonGoster(d.uzanti)}</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 500, fontSize: 13, color: 'var(--med-primary)' }}>{d.projeAdi || d.projeTurAd}</div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>
                {tarihFormat(d.tar)}
                {d.aciklama && d.aciklama !== 'Mobil' && ` · ${d.aciklama}`}
              </div>
            </div>
            <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 6 }}>
              <span style={{ background: '#E8F0FD', color: '#0D2B5E', padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600, textTransform: 'uppercase' }}>{d.uzanti}</span>
              <span style={{ fontSize: 18, color: 'var(--med-accent)' }}>›</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

function TanilarSekme({ kayitNo, masterProtNo, yetki, hasta, kullanici }) {
  const [liste, setListe] = React.useState([]);
  const [yukleniyor, setYukleniyor] = React.useState(true);
  const [formAcik, setFormAcik] = React.useState(false);
  const [aramaMetni, setAramaMetni] = React.useState('');
  const [sonuclar, setSonuclar] = React.useState([]);
  const [aramaYukleniyor, setAramaYukleniyor] = React.useState(false);
  const [secilenTani, setSecilenTani] = React.useState(null);
  const [kaydediliyor, setKaydediliyor] = React.useState(false);
  const [mesaj, setMesaj] = React.useState('');
  const aramaTimer = React.useRef(null);

  const yukle = async () => {
    try {
      const res = await getTaniListe(kayitNo, masterProtNo);
      setListe(res.data);
    } catch (err) { console.error(err); }
    finally { setYukleniyor(false); }
  };

  React.useEffect(() => { yukle(); }, []);

  const tarihFormat = (tar) => {
    if (!tar) return '-';
    const d = new Date(tar);
    return String(d.getDate()).padStart(2,'0') + '/' + String(d.getMonth()+1).padStart(2,'0') + '/' + d.getFullYear();
  };

  const aramaYap = (deger) => {
    setAramaMetni(deger);
    setSecilenTani(null);
    if (aramaTimer.current) clearTimeout(aramaTimer.current);
    if (deger.length < 3) { setSonuclar([]); return; }
    aramaTimer.current = setTimeout(async () => {
      setAramaYukleniyor(true);
      try {
        const res = await icd10Ara(deger);
        setSonuclar(res.data);
      } catch { setSonuclar([]); }
      finally { setAramaYukleniyor(false); }
    }, 400);
  };

  const taniSec = (t) => {
    setSecilenTani(t);
    setAramaMetni(t.kod + ' - ' + t.adi);
    setSonuclar([]);
  };

  const kaydet = async () => {
    if (!secilenTani) { setMesaj('Lütfen bir tanı seçin!'); return; }
    setKaydediliyor(true);
    try {
      // Token girişinde DOKTOR/DOKKOD → BILDIRIMLER.ALICI_ADI / ALICI_KOD kullan
      const doktor = kullanici.aliciAdi || kullanici.adSoyad;
      const dokKod = kullanici.aliciKod || kullanici.dokKod;
      await taniEkle({
        masterProtNo: parseInt(masterProtNo),
        kayitNo: parseInt(kayitNo),
        adSoy: hasta?.hesapAdi,
        dokKod,
        doktor,
        kod: secilenTani.kod,
        adi: secilenTani.adi,
      });
      await yukle();
      setFormAcik(false);
      setAramaMetni('');
      setSecilenTani(null);
      setSonuclar([]);
      setMesaj('Tanı eklendi ✓');
      setTimeout(() => setMesaj(''), 2000);
    } catch { setMesaj('Hata oluştu!'); }
    finally { setKaydediliyor(false); }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <span style={{ fontSize: 13, fontWeight: 600 }}>Tanılar</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {mesaj && <span style={{ fontSize: 12, color: '#2563C0', fontWeight: 500 }}>{mesaj}</span>}
          {yetki && !formAcik && (
            <button className="btn btn-primary" style={{ fontSize: 12, padding: '6px 14px' }}
              onClick={() => { setFormAcik(true); setAramaMetni(''); setSecilenTani(null); setSonuclar([]); }}>
              ➕ Tanı Ekle
            </button>
          )}
        </div>
      </div>

      {formAcik && (
        <div className="card" style={{ marginBottom: 12 }}>
          <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 12, color: 'var(--med-primary)' }}>YENİ TANI EKLE</div>
          <div style={{ marginBottom: 8 }}>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 500, marginBottom: 5 }}>ICD10 Tanı Ara (min. 3 karakter)</div>
            <input
              type="text"
              placeholder="Tanı adı veya kodu yazın..."
              value={aramaMetni}
              onChange={e => aramaYap(e.target.value)}
              autoFocus
            />
          </div>
          {aramaYukleniyor && <div style={{ fontSize: 12, color: 'var(--text-muted)', padding: '8px 0' }}>Aranıyor...</div>}
          {sonuclar.length > 0 && (
            <div style={{ border: '1px solid var(--border)', borderRadius: 8, maxHeight: 220, overflowY: 'auto', marginBottom: 10 }}>
              {sonuclar.map((s, i) => (
                <div key={i}
                  style={{ padding: '8px 12px', borderBottom: '1px solid var(--border)', cursor: 'pointer', fontSize: 13, display: 'flex', gap: 10, alignItems: 'center' }}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--med-light)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  onClick={() => taniSec(s)}
                >
                  <span style={{ background: '#E8F0FD', color: '#0D2B5E', padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600, flexShrink: 0 }}>{s.kod}</span>
                  <span>{s.adi}</span>
                </div>
              ))}
            </div>
          )}
          {secilenTani && (
            <div style={{ padding: '10px 14px', background: '#E8F0FD', borderRadius: 8, marginBottom: 10, fontSize: 13 }}>
              ✓ Seçilen: <strong>{secilenTani.kod}</strong> — {secilenTani.adi}
            </div>
          )}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button className="btn btn-secondary" onClick={() => { setFormAcik(false); setAramaMetni(''); setSonuclar([]); setSecilenTani(null); }}>İptal</button>
            <button className="btn btn-primary" disabled={kaydediliyor || !secilenTani} onClick={kaydet}>
              {kaydediliyor ? 'Kaydediliyor...' : '💾 Kaydet'}
            </button>
          </div>
        </div>
      )}

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {yukleniyor ? <div className="loading">Yükleniyor...</div>
        : liste.length === 0 ? <div className="empty">Tanı kaydı yok</div>
        : (
          <div style={{ overflowX: 'auto' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '90px 160px 90px 1fr', minWidth: 620, padding: '8px 16px', background: '#f8faf9', borderBottom: '1px solid var(--border)', fontSize: 11, color: 'var(--text-muted)', fontWeight: 500 }}>
              <span>Tarih</span><span>Doktor</span><span>Kod</span><span>Tanı Adı</span>
            </div>
            {liste.map(t => (
              <div key={t.id} style={{ display: 'grid', gridTemplateColumns: '90px 160px 90px 1fr', minWidth: 620, padding: '10px 16px', borderBottom: '1px solid var(--border)', alignItems: 'center' }}>
                <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{tarihFormat(t.tar)}</span>
                <span style={{ fontSize: 13, fontWeight: 500 }}>{t.doktor}</span>
                <span><span style={{ background: '#E8F0FD', color: '#0D2B5E', padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600 }}>{t.kod}</span></span>
                <span style={{ fontSize: 13 }}>{t.adi}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function AnamnezSekme({ kayitNo, masterProtNo, hasta, kullanici, yetki, baslik, alanlar, getListe, getDetay, yeniKayit, guncelleKayit, silKayit }) {
  const [liste, setListe] = useState([]);
  const [seciliId, setSeciliId] = useState(null);
  const [detay, setDetay] = useState(null);
  const [mod, setMod] = useState(null);
  const [form, setForm] = useState(() => Object.fromEntries(alanlar.map(a => [a.key, ''])));
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [mesaj, setMesaj] = useState('');

  const listeYukle = async () => {
    try {
      const res = await getListe(kayitNo, masterProtNo);
      setListe(res.data);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { listeYukle(); }, []);

  const tarihFormat = (tar) => tar ? new Date(tar).toLocaleDateString('tr-TR') : '-';

  const kaydet = async () => {
    setKaydediliyor(true);
    try {
      if (mod === 'yeni') {
        // Token girişinde WHO/WHONO → BILDIRIMLER.ALICI_ADI / ALICI_KOD kullan
        const who   = kullanici.aliciAdi  || kullanici.adSoyad;
        const whoNo = kullanici.aliciKod  || kullanici.noo;
        const yeniData = { kayitNo: parseInt(kayitNo), adSoy: hasta?.hesapAdi, masterProtNo: parseInt(masterProtNo), who, whoNo };
        alanlar.forEach(a => { yeniData[a.key] = form[a.key]; });
        await yeniKayit(yeniData);
      } else {
        const guncData = { ...detay };
        alanlar.forEach(a => { guncData[a.key] = form[a.key]; });
        await guncelleKayit(detay.id, guncData);
        const res = await getDetay(detay.id);
        setDetay(res.data);
        setMod('goruntule');
      }
      await listeYukle();
      if (mod === 'yeni') setMod(null);
      setMesaj(mod === 'yeni' ? 'Kaydedildi ✓' : 'Güncellendi ✓');
      setTimeout(() => setMesaj(''), 2000);
    } catch { setMesaj('Hata!'); }
    finally { setKaydediliyor(false); }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <span style={{ fontSize: 13, fontWeight: 600 }}>{baslik}</span>
        {yetki && mod !== 'yeni' && (
          <button className="btn btn-primary" style={{ fontSize: 12, padding: '6px 14px' }} onClick={() => {
            setMod('yeni'); setDetay(null); setSeciliId(null);
            setForm(Object.fromEntries(alanlar.map(a => [a.key, ''])));
          }}>➕ Kayıt Ekle</button>
        )}
      </div>

      {mod === 'yeni' && (
        <div className="card" style={{ marginBottom: 12 }}>
          <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 12 }}>Yeni Kayıt</div>
          {alanlar.map(a => (
            <div key={a.key} style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 4 }}>{a.etiket}</div>
              <textarea rows={3} style={{ width: '100%', padding: '8px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, resize: 'vertical', background: a.renk, fontFamily: 'inherit' }}
                value={form[a.key]} onChange={e => setForm(prev => ({ ...prev, [a.key]: e.target.value }))} />
            </div>
          ))}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button className="btn btn-secondary" onClick={() => setMod(null)}>İptal</button>
            <button className="btn btn-primary" disabled={kaydediliyor} onClick={kaydet}>
              {kaydediliyor ? 'Kaydediliyor...' : '💾 Kaydet'}
            </button>
          </div>
          {mesaj && <div style={{ marginTop: 8, fontSize: 12, color: '#2563C0', textAlign: 'right' }}>{mesaj}</div>}
        </div>
      )}

      <div className="card" style={{ padding: 0, overflow: 'hidden', marginBottom: 12 }}>
        {liste.length === 0 ? <div className="empty">Henüz kayıt yok</div>
        : liste.map(k => (
          <div key={k.id}
            style={{ padding: '10px 16px', borderBottom: '1px solid var(--border)', cursor: 'pointer', background: seciliId === k.id ? 'var(--med-light)' : 'transparent', borderLeft: seciliId === k.id ? '3px solid var(--med-accent)' : '3px solid transparent' }}
            onClick={async () => {
              setSeciliId(k.id); setMod('goruntule');
              const res = await getDetay(k.id);
              setDetay(res.data);
            }}
          >
            <span style={{ fontWeight: 500, fontSize: 13, color: 'var(--med-primary)' }}>
              {tarihFormat(k.tar)} - {k.saat} · {k.who}
            </span>
          </div>
        ))}
      </div>

      {detay && mod === 'goruntule' && (
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, paddingBottom: 8, borderBottom: '1px solid var(--border)' }}>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{tarihFormat(detay.tar)} {detay.saat} · {detay.who}</div>
            {yetki && (
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-secondary" style={{ fontSize: 12 }} onClick={() => {
                  setMod('duzenle');
                  setForm(Object.fromEntries(alanlar.map(a => [a.key, detay[a.key] || ''])));
                }}>✏️ Düzenle</button>
                <button className="btn" style={{ fontSize: 12, background: '#FCEBEB', color: '#A32D2D', border: '1px solid #F7C1C1' }} onClick={async () => {
                  if (!window.confirm('Silinecek. Emin misiniz?')) return;
                  await silKayit(detay.id);
                  await listeYukle();
                  setDetay(null); setSeciliId(null); setMod(null);
                }}>🗑️ Sil</button>
              </div>
            )}
          </div>
          {alanlar.map(a => detay[a.key] && (
            <div key={a.key} style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 4 }}>{a.etiket}</div>
              <div style={{ padding: '10px 14px', background: a.renk, borderRadius: 8, fontSize: 13, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{detay[a.key]}</div>
            </div>
          ))}
        </div>
      )}

      {detay && mod === 'duzenle' && (
        <div className="card">
          <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 12, paddingBottom: 8, borderBottom: '1px solid var(--border)' }}>Kayıt Düzenle</div>
          {alanlar.map(a => (
            <div key={a.key} style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 4 }}>{a.etiket}</div>
              <textarea rows={3} style={{ width: '100%', padding: '8px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, resize: 'vertical', background: a.renk, fontFamily: 'inherit' }}
                value={form[a.key]} onChange={e => setForm(prev => ({ ...prev, [a.key]: e.target.value }))} />
            </div>
          ))}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button className="btn btn-secondary" onClick={() => setMod('goruntule')}>İptal</button>
            <button className="btn btn-primary" disabled={kaydediliyor} onClick={kaydet}>
              {kaydediliyor ? 'Kaydediliyor...' : '💾 Güncelle'}
            </button>
          </div>
          {mesaj && <div style={{ marginTop: 8, fontSize: 12, color: '#2563C0', textAlign: 'right' }}>{mesaj}</div>}
        </div>
      )}
    </div>
  );
}

export default function HastaDetay() {
  const { kayitNo } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const masterProtNo = params.get('mprotno');

  const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');
  const yetk50 = kullanici.yetk50 === 1;
  const yetk53 = kullanici.yetk53 === 1;
  const hastaGirisi = kullanici.girisTipi === 1;

  const [hasta, setHasta] = useState(null);
  const [gelisler, setGelisler] = useState([]);
  const [temelMed, setTemelMed] = useState([]);
  const [temelMedDuzenle, setTemelMedDuzenle] = useState({});
  const [aktifSekme, setAktifSekme] = useState('kimlik');
  const [yukleniyor, setYukleniyor] = useState(true);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [mesaj, setMesaj] = useState('');
  const [yetkisiz, setYetkisiz] = useState(false);

  useEffect(() => {
        const yukle = async () => {
          try {
            const [hastaRes, gelisRes, temelMedRes] = await Promise.all([
              getHasta(kayitNo), getHastaGelisleri(kayitNo), getTemelMed(kayitNo)
            ]);
            setHasta(hastaRes.data);
            setGelisler(gelisRes.data);
            setTemelMed(temelMedRes.data.alanlar || []);
            const baslangic = {};
            (temelMedRes.data.alanlar || []).forEach(a => { baslangic[a.siraNo] = a.deger || ''; });
            setTemelMedDuzenle(baslangic);
          } catch (err) {
            if (err.response?.status === 403) {
              setYetkisiz(true);
            } else {
              console.error(err);
              setTimeout(() => yukle(), 1500);
            }
          }
          finally { setYukleniyor(false); }
        };
        yukle();
      }, [kayitNo]);

  const tarihFormat = (tar) => tar ? new Date(tar).toLocaleDateString('tr-TR') : '-';
  const adresDetayVar = hasta && [hasta.detay0, hasta.detay1, hasta.detay2, hasta.detay3, hasta.detay4, hasta.detay5, hasta.detay6, hasta.detay7, hasta.detay8, hasta.detay9, hasta.detay10].some(d => d && d.trim() !== '');
  const yakiniVar = hasta && [hasta.yakini0, hasta.yakini1, hasta.yakini2, hasta.yakini3].some(d => d && d.trim() !== '');

  if (yukleniyor) return <div className="loading">Yükleniyor...</div>;

  if (yetkisiz) return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(160deg, #e8f4f8 0%, #f0eaff 50%, #eafaf1 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: 24, textAlign: 'center'
    }}>
      <img src="/images/kurum_logo_200.png" alt="Logo" style={{ maxWidth: 220, marginBottom: 32, objectFit: 'contain' }} />
      <div style={{ fontSize: 80, marginBottom: 16 }}>🔒</div>
      <div style={{
        background: '#fff', borderRadius: 18,
        boxShadow: '0 8px 32px rgba(100,80,200,.15)',
        overflow: 'hidden', maxWidth: 380, width: '100%'
      }}>
        <div style={{ background: 'linear-gradient(135deg, #c0392b, #e74c3c)', padding: '18px 24px' }}>
          <div style={{ color: '#fff', fontSize: 18, fontWeight: 700 }}>⛔ Yetkisiz Erişim</div>
          <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 12, marginTop: 4 }}>Bu sayfaya erişim yetkiniz bulunmamaktadır</div>
        </div>
        <div style={{ padding: '24px' }}>
          <p style={{ color: '#555', fontSize: 14, lineHeight: 1.6, marginBottom: 24 }}>
            Yalnızca kendi tıbbi dosyanıza erişebilirsiniz.<br />
            Başka bir hastanın kaydına erişim <strong>yasaktır</strong> ve kayıt altına alınmaktadır.
          </p>
          <button
            onClick={() => {
              localStorage.clear();
              window.location.href = '/mobil/hasta-giris';
            }}
            style={{
              width: '100%', padding: '13px',
              background: 'linear-gradient(135deg, #7C5CBF, #a07de0)',
              color: '#fff', border: 'none', borderRadius: 10,
              fontSize: 15, fontWeight: 700, cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(124,92,191,.35)'
            }}
          >
            🔐 Giriş Sayfasına Dön
          </button>
        </div>
      </div>
    </div>
  );

  if (!hasta) return <div className="empty">Hasta bulunamadı</div>;

  const sekmeler = [
    { key: 'kimlik',     label: '👤 Temel Kimlik' },
    { key: 'medikal',    label: '🏥 Sabit Medikal' },
    { key: 'hemsire',    label: '👩‍⚕️ Hemşire Anamnezi' },
    { key: 'doktor',     label: '🩺 Doktor Anamnezi' },
    { key: 'tanilar',    label: '📌 Tanılar' },
    { key: 'order',      label: '💊 Tedavi Order' },
    { key: 'dokumanlar', label: '📄 Dökümanlar' },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        {!hastaGirisi
          ? <button className="btn btn-secondary" style={{ fontSize: 12 }} onClick={() => navigate(-1)}>← Geri</button>
          : <span />
        }
        {hastaGirisi && (
          <button
            onClick={() => { localStorage.clear(); window.location.href = '/mobil/hasta-giris'; }}
            style={{
              padding: '8px 18px', background: 'linear-gradient(135deg, #7C5CBF, #a07de0)',
              color: '#fff', border: 'none', borderRadius: 8, fontSize: 13,
              fontWeight: 600, cursor: 'pointer', boxShadow: '0 2px 8px rgba(124,92,191,.3)'
            }}
          >
            🚪 Çıkış
          </button>
        )}
      </div>

      <div style={{ background: 'var(--med-dark)', borderRadius: 'var(--radius)', padding: '16px', marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{ width: 44, height: 44, borderRadius: '50%', background: 'var(--med-accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 600, color: '#fff', flexShrink: 0 }}>
            {hasta.hesapAdi?.split(' ').map(n => n[0]).join('').slice(0, 2)}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ color: '#fff', fontWeight: 600, fontSize: 15 }}>{hasta.hesapAdi}</div>
            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, marginTop: 2 }}>#{hasta.kayitNo} · {hasta.cinsiyet === 'E' ? 'Erkek' : hasta.cinsiyet === 'K' ? 'Kadın' : hasta.cinsiyet} · D.T: {hasta.dogTar}</div>
          </div>
          <div style={{ display: 'flex', gap: 20 }}>
            {hasta.kanGrubu && <div style={{ textAlign: 'center' }}><div style={{ color: '#A8C4F0', fontSize: 13, fontWeight: 600 }}>{hasta.kanGrubu}</div><div style={{ color: 'rgba(255,255,255,0.35)', fontSize: 10 }}>Kan Grubu</div></div>}
            <div style={{ textAlign: 'center' }}><div style={{ color: '#A8C4F0', fontSize: 13, fontWeight: 600 }}>{gelisler.length}</div><div style={{ color: 'rgba(255,255,255,0.35)', fontSize: 10 }}>Geliş</div></div>
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 2, marginBottom: 14, borderBottom: '1px solid var(--border)', flexWrap: 'wrap' }}>
        {sekmeler.map(s => (
          <button key={s.key} onClick={() => setAktifSekme(s.key)} style={{
            padding: '8px 12px', border: 'none', background: 'none', cursor: 'pointer',
            fontSize: 12, fontWeight: aktifSekme === s.key ? 600 : 400,
            color: aktifSekme === s.key ? 'var(--med-primary)' : 'var(--text-muted)',
            borderBottom: aktifSekme === s.key ? '2px solid var(--med-accent)' : '2px solid transparent',
            marginBottom: -1, whiteSpace: 'nowrap',
          }}>{s.label}</button>
        ))}
      </div>

      {aktifSekme === 'kimlik' && (
        <div className="card">
          <Bolum baslik="TEMEL KİMLİK BİLGİLERİ">
            <BilgiSatiri etiket="Adı Soyadı" deger={hasta.hesapAdi} />
            <BilgiSatiri etiket="TC Kimlik" deger={hasta.tcKimlik ? hasta.tcKimlik.slice(0,3) + '*****' + hasta.tcKimlik.slice(8,11) : ''} />
            <BilgiSatiri etiket="D.Tarihi" deger={hasta.dogTar} />
            <BilgiSatiri etiket="Cep Telefonu" deger={hasta.cepTel} tel={true} />
            <BilgiSatiri etiket="İl" deger={hasta.sehir} />
            <BilgiSatiri etiket="İlçe" deger={hasta.ilce} />
            <BilgiSatiri etiket="Adres" deger={hasta.adres1} />
          </Bolum>
          {adresDetayVar && (
            <Bolum baslik="ADRES DETAYI">
              {hasta.detay0 && <BilgiSatiri etiket="Mahalle" deger={hasta.detay0} />}
              {hasta.detay1 && <BilgiSatiri etiket="Cadde" deger={hasta.detay1} />}
              {hasta.detay2 && <BilgiSatiri etiket="Sokak" deger={hasta.detay2} />}
              {hasta.detay3 && <BilgiSatiri etiket="İç Sokak" deger={hasta.detay3} />}
              {hasta.detay4 && <BilgiSatiri etiket="Apartman Adı" deger={hasta.detay4} />}
              {hasta.detay5 && <BilgiSatiri etiket="Apartman No" deger={hasta.detay5} />}
              {hasta.detay6 && <BilgiSatiri etiket="Daire No" deger={hasta.detay6} />}
              {hasta.detay7 && <BilgiSatiri etiket="Kat" deger={hasta.detay7} />}
              {hasta.detay8 && <BilgiSatiri etiket="Zil Sırası" deger={hasta.detay8} />}
              {hasta.detay10 && <BilgiSatiri etiket="Google Maps" deger={hasta.detay10} link={true} />}
              {hasta.detay9 && <BilgiSatiri etiket="Adres Tarifi" deger={hasta.detay9} />}
            </Bolum>
          )}
          {yakiniVar && (
            <Bolum baslik="1. HASTA YAKINI">
              {hasta.yakini0 && <BilgiSatiri etiket="Adı Soyadı" deger={hasta.yakini0} />}
              {hasta.yakini1 && <BilgiSatiri etiket="Yakınlığı" deger={hasta.yakini1} />}
              {hasta.yakini2 && <BilgiSatiri etiket="Telefonu" deger={hasta.yakini2} tel={true} />}
              {hasta.yakini3 && <BilgiSatiri etiket="Adresi" deger={hasta.yakini3} />}
            </Bolum>
          )}
        </div>
      )}

      {aktifSekme === 'medikal' && (
        <div className="card">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14, paddingBottom: 8, borderBottom: '1px solid var(--border)' }}>
            <span style={{ fontWeight: 600, fontSize: 13, color: 'var(--med-primary)' }}>SABİT MEDİKAL BİLGİLER</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              {mesaj && <span style={{ fontSize: 12, color: '#2563C0', fontWeight: 500 }}>{mesaj}</span>}
              {!hastaGirisi && <button className="btn btn-primary" style={{ padding: '6px 16px', fontSize: 12 }} disabled={kaydediliyor} onClick={async () => {
                setKaydediliyor(true);
                try { await guncelleTemelMed(parseInt(kayitNo), temelMedDuzenle); setMesaj('Kaydedildi ✓'); setTimeout(() => setMesaj(''), 2000); }
                catch { setMesaj('Hata!'); } finally { setKaydediliyor(false); }
              }}>
                {kaydediliyor ? 'Kaydediliyor...' : '💾 Güncelle'}
              </button>}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {temelMed.map(alan => (
              <div key={alan.siraNo}>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 500, marginBottom: 5 }}>{alan.etiket}</div>
                <textarea rows={3} style={{ width: '100%', padding: '8px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, resize: 'vertical', fontFamily: 'inherit' }}
                  value={temelMedDuzenle[alan.siraNo] || ''}
                  onChange={e => setTemelMedDuzenle(prev => ({ ...prev, [alan.siraNo]: e.target.value }))}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {aktifSekme === 'hemsire' && (
        <AnamnezSekme
          kayitNo={kayitNo} masterProtNo={masterProtNo} hasta={hasta} kullanici={kullanici} yetki={yetk50}
          baslik="Hemşire Anamnezi Kayıtları"
          alanlar={[
            { key: 'ack1', etiket: 'HEMŞİRE ANAMNEZİ', renk: '#E8F0FD' },
            { key: 'ack2', etiket: 'HEMŞİRE MUAYENE BULGULARI', renk: '#FAEEDA' },
            { key: 'ack3', etiket: 'HEMŞİRE ÖN TANILARI', renk: '#FFF9C4' },
            { key: 'ack4', etiket: 'HEMŞİRE MÜDAHALELERİ', renk: '#FCE4EC' },
          ]}
          getListe={getAnamnezHemsListe} getDetay={getAnamnezHemsDetay}
          yeniKayit={yeniAnamnezHems} guncelleKayit={guncelleAnamnezHems} silKayit={silAnamnezHems}
        />
      )}

      {aktifSekme === 'doktor' && (
        <AnamnezSekme
          kayitNo={kayitNo} masterProtNo={masterProtNo} hasta={hasta} kullanici={kullanici} yetki={yetk53}
          baslik="Doktor Anamnezi Kayıtları"
          alanlar={[
            { key: 'anamnez', etiket: 'ANAMNEZİ', renk: '#E6F1FB' },
            { key: 'bulgular', etiket: 'BULGULAR', renk: '#EAF3DE' },
          ]}
          getListe={getAnamnezDoktorListe} getDetay={getAnamnezDoktorDetay}
          yeniKayit={yeniAnamnezDoktor} guncelleKayit={guncelleAnamnezDoktor} silKayit={silAnamnezDoktor}
        />
      )}

      {aktifSekme === 'tanilar' && (
        <TanilarSekme kayitNo={kayitNo} masterProtNo={masterProtNo} yetki={yetk53} hasta={hasta} kullanici={kullanici} />
      )}

      {aktifSekme === 'order' && (
        <AnamnezSekme
          kayitNo={kayitNo} masterProtNo={masterProtNo} hasta={hasta} kullanici={kullanici} yetki={yetk53}
          baslik="Tedavi Order Kayıtları"
          alanlar={[
            { key: 'ack1', etiket: 'Tedavi Order', renk: '#E6F1FB' },
            { key: 'ack2', etiket: 'Tetkik İstem', renk: '#EAF3DE' },
            { key: 'ack3', etiket: 'Konsültasyon İsteği', renk: '#FAEEDA' },
            { key: 'ack4', etiket: 'Öneriler', renk: '#FFF9C4' },
            { key: 'tani', etiket: 'Kontrol Planı', renk: '#FCE4EC' },
          ]}
          getListe={getDoktorOrderListe} getDetay={getDoktorOrderDetay}
          yeniKayit={yeniDoktorOrder} guncelleKayit={guncelleDoktorOrder} silKayit={silDoktorOrder}
        />
      )}

      {aktifSekme === 'dokumanlar' && (
        <DokumanlarSekme kayitNo={kayitNo} hasta={hasta} hastaGirisi={hastaGirisi} />
      )}

    </div>
  );
}